import * as _ from 'lodash';
import messages from '../../const/messages';
import isValidUrl from '../mini/isValidUrl';

export function validateWakeWordPath(url: string): string | null {
    const isValid = isValidUrl(url);

    if (!isValid) {
        return messages.wakeWordPathContainsInvalidUrl;
    }

    if (!(url.startsWith('https://storage.googleapis.com/') && (
        url.endsWith('.rar') || url.endsWith('.zip') || url.endsWith('.tar') || url.endsWith('.tar.gz')
    ))) {
        return messages.wakeWordPathHasInvalidFormat;
    }
    return null;
}